interface MartiniIconProps {
  width?: string
  height?: string
  selected?: boolean
  color?: string
  className?: string
}

const MartiniIcon = ({
  color = '#D5DCEB',
  width = '55',
  height = '58',
  selected = false,
  className,
  ...props
}: MartiniIconProps) => (
  <svg
    {...props}
    className={className}
    width={width}
    height={height}
    viewBox="0 0 55 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="martiniIconGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#3CCEA2" />
        <stop offset="100%" stopColor="#FFD600" />
      </linearGradient>
    </defs>
    <path
      d="M26.8021 37.7026C26.3121 37.7026 25.8421 37.5127 25.4921 37.1627L0.872062 12.5327C0.342062 12.0027 0.182068 11.2126 0.472068 10.5226C0.762068 9.83264 1.43208 9.38263 2.18208 9.38263H18.4921C19.5121 9.38263 20.3421 10.2127 20.3421 11.2327C20.3421 12.2527 19.5121 13.0826 18.4921 13.0826H6.63207L26.8021 33.2526L46.9721 13.0826H46.7621C45.7421 13.0826 44.9121 12.2527 44.9121 11.2327C44.9121 10.2127 45.7421 9.38263 46.7621 9.38263H51.4221C52.1721 9.38263 52.8421 9.83264 53.1321 10.5226C53.4221 11.2126 53.2621 12.0027 52.7321 12.5327L28.1021 37.1627C27.7521 37.5127 27.2821 37.7026 26.7921 37.7026H26.8021Z"
      fill={selected ? 'url(#martiniIconGradient)' : 'currentColor'}
    />
    <path
      d="M26.8022 52.7526C25.7822 52.7526 24.9521 51.9226 24.9521 50.9026V35.8527C24.9521 34.8327 25.7822 34.0026 26.8022 34.0026C27.8222 34.0026 28.6522 34.8327 28.6522 35.8527V50.9026C28.6522 51.9226 27.8222 52.7526 26.8022 52.7526Z"
      fill={selected ? 'url(#martiniIconGradient)' : 'currentColor'}
    />
    <path
      d="M20.3718 24.2227C19.7618 24.2227 19.1618 23.9226 18.8118 23.3726C18.2618 22.5126 18.5118 21.3726 19.3718 20.8226L22.0918 19.0827C22.9518 18.5327 24.0918 18.7827 24.6418 19.6427C25.1918 20.5027 24.9419 21.6426 24.0819 22.1926L21.3618 23.9327C21.0518 24.1327 20.7118 24.2227 20.3718 24.2227Z"
      fill={selected ? 'url(#martiniIconGradient)' : 'currentColor'}
    />
    <path
      d="M33.1018 16.0827C32.4918 16.0827 31.9018 15.7827 31.5418 15.2327C30.9918 14.3727 31.2418 13.2327 32.1018 12.6827L51.5118 0.282672C52.3718 -0.267328 53.5118 -0.0173304 54.0618 0.84267C54.6118 1.70267 54.3618 2.84266 53.5018 3.39266L34.0918 15.7927C33.7818 15.9927 33.4418 16.0827 33.1018 16.0827Z"
      fill={selected ? 'url(#martiniIconGradient)' : 'currentColor'}
    />
    <path
      d="M28.2318 24.9726C24.1418 24.9726 20.7918 21.7627 20.6218 17.6727C20.4418 13.4727 23.7118 9.90264 27.9118 9.72264C32.1918 9.53264 35.6818 12.8126 35.8618 17.0226C36.0418 21.2226 32.7718 24.7926 28.5618 24.9726C28.4518 24.9726 28.3418 24.9726 28.2318 24.9726ZM28.2418 13.4126H28.0718C25.9018 13.5126 24.2118 15.3526 24.3118 17.5226C24.4018 19.6326 26.1218 21.2826 28.2318 21.2826H28.4118C30.5818 21.1826 32.2718 19.3427 32.1818 17.1827C32.0918 15.0727 30.3618 13.4126 28.2518 13.4126H28.2418Z"
      fill={selected ? 'url(#martiniIconGradient)' : 'currentColor'}
    />
    <path
      d="M37.682 57.6727H15.912C14.892 57.6727 14.062 56.8426 14.062 55.8226C14.062 54.8026 14.892 53.9727 15.912 53.9727H37.682C38.702 53.9727 39.532 54.8026 39.532 55.8226C39.532 56.8426 38.702 57.6727 37.682 57.6727Z"
      fill={selected ? 'url(#martiniIconGradient)' : 'currentColor'}
    />
  </svg>
)

export default MartiniIcon
